import { render, staticRenderFns } from "./ParkingPlateApproval.vue?vue&type=template&id=03cb5e78"
import script from "./ParkingPlateApproval.vue?vue&type=script&lang=js"
export * from "./ParkingPlateApproval.vue?vue&type=script&lang=js"
import style0 from "./ParkingPlateApproval.vue?vue&type=style&index=0&id=03cb5e78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports